import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const EuroIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12.518 4c1.846 0 3.48.986 4.482 2.5l-1.61 1c-.675-.914-1.71-1.5-2.872-1.5-1.714 0-3.155 1.275-3.563 3H13v2H8.839v2H13v2H8.955c.408 1.725 1.849 3 3.563 3 1.161 0 2.198-.585 2.872-1.5l1.61 1c-1.002 1.514-2.636 2.5-4.482 2.5-2.734 0-5.002-2.163-5.44-5H5v-2h2v-2H5V9h2.078c.438-2.838 2.706-5 5.44-5"
    />
  </BaseIcon>
)
